import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
//MUI
import { useTheme, Slider, Checkbox, Typography } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import VolumeUp from '@mui/icons-material/VolumeUp';
import OpacityIcon from '@mui/icons-material/Opacity';
import LocalMoviesIcon from '@mui/icons-material/LocalMovies';
import { Fullscreen } from '@mui/icons-material';
import LayersIcon from '@mui/icons-material/Layers';

//Controller
import { useVideoController } from "./useVideoController";
import { getSelectedType } from "../../../commonFunction";
import { SelectedItemID_Store } from "../../../../../store/actions/webgldata";

import './ElementContextMenu.scss';

function ElementContextMenu({ menuVisible, menuPosition }) {

    const ProjectData = useSelector(store => store.projectdata.projectJSON);
    const selectedID = useSelector((store) => store.webgldata.selectedItemID);
    const [adjustedPosition, setAdjustedPosition] = useState({ x: -500, y: -500 });
    const [finalMenuVisible, setFinalMenuVisible] = useState(false);
    const [menuType, setMenuType] = useState([]);
    const menuRef = useRef(null);
    const theme = useTheme();

    //Controller functions
    const {
        ItemRemoveFunc,
        duplicateFunction,
        splitFunction,
        levelUpDown,
        selected,
        opacity,
        setOpacity,
        changedOpacity,
        stretchScreenVideo,
        volumeValue,
        setVolumeValue,
        changedVolume,
        onFreezeFrame,
        removeGroup,
        VideoPlayFunc
    } = useVideoController();

    useEffect(() => {
        //Set menu type
        if (selectedID && ProjectData) {
            const type = getSelectedType(selectedID, ProjectData);

            if (type === 'videos') {
                setMenuType(videoMenu);
            } else if (type === 'images' || type === 'text') {
                setMenuType(imageMenu);
            } else if (type === 'audios') {
                setMenuType(audioMenu)
            }
        }

        //Display menu
        if (menuVisible && menuRef.current) {
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            const menuWidth = 260;
            const menuHeight = menuRef.current.offsetHeight;

            let xPos = menuPosition.x;
            let yPos = menuPosition.y;

            if (xPos + menuWidth > viewportWidth) {
                xPos = viewportWidth - menuWidth;
            }
            if (yPos + menuHeight > viewportHeight) {
                yPos = viewportHeight - menuHeight;
            }

            setAdjustedPosition({ x: xPos, y: yPos });
            setFinalMenuVisible(true);
            VideoPlayFunc(false);
        } else {
            setFinalMenuVisible(false);
        }
    }, [selectedID, ProjectData, menuVisible, menuPosition]);

    //Menu types
    const baseMenu = [
        { icon: <ContentCopyIcon />, label: "Duplicate", function: duplicateFunction },
        { icon: <ContentCutIcon />, label: "Split", function: splitFunction },
        { icon: <DeleteOutlineIcon />, label: "Remove", function: ItemRemoveFunc },
        { icon: <DeleteSweepIcon />, label: "Delete Row", function: removeGroup },
    ];

    const layeredMenu = [
        ...baseMenu,
        { icon: <LayersIcon />, label: `Layer`, submenu: true },
        { icon: <OpacityIcon />, label: "Opacity", submenu: true },
        { icon: <Fullscreen />, label: "Fullscreen", function: stretchScreenVideo },
    ];

    const videoMenu = [
        ...layeredMenu,
        { icon: <VolumeUp />, label: "Volume", submenu: true },
        {
            icon: <LocalMoviesIcon />, label: "Freeze", function: onFreezeFrame,

        },
    ];

    const imageMenu = [...layeredMenu];

    const audioMenu = [...baseMenu,
        { icon: <VolumeUp />, label: "Volume", submenu: true },
    ];

    return (
        <div style={{ height: '100vh', overflow: 'hidden', zIndex: finalMenuVisible ? '99999' : '-999999', opacity: finalMenuVisible ? 1 : 0 }}>
            <ul
                ref={menuRef}
                className="context-menu"
                style={{ top: `${adjustedPosition.y}px`, left: `${adjustedPosition.x}px`, backgroundColor: theme.palette.background.paper }} >
                {menuType && menuType.map((item, index) => {
                    if (item === "divider") {
                        return <hr key={index} className="menu-divider" />
                    }
                    /* Layer menu */
                    else if (item.label === 'Layer') {
                        return (<li key={index} className={item.submenu ? "has-submenu disableExit" : ""}>
                            {item.icon}
                            {item.label}
                            &nbsp;
                            &lt; {selected?.coordinate?.zIndex + 9} &gt;
                            {item.submenu && (
                                <ul
                                    className="submenu disableExit"
                                    style={{
                                        bottom: "-4px",
                                        left: adjustedPosition.x + 240 + 150 > window.innerWidth ? -150 : 240,
                                        backgroundColor: theme.palette.background.paper
                                    }}
                                >
                                    <li className="disableExit" onClick={() => levelUpDown(1)}>
                                        <ArrowUpwardOutlinedIcon className="disableExit" />
                                        <Typography className="disableExit">Bring to Front</Typography>
                                    </li>
                                    <li className="disableExit" onClick={() => levelUpDown(-1)}>
                                        <ArrowDownwardOutlinedIcon className="disableExit" />
                                        <Typography className="disableExit">Send to Back</Typography>
                                    </li>
                                </ul>
                            )}
                        </li>)
                    }
                    /* Volume menu */
                    else if (item.label === 'Volume') {
                        return (<li key={index} className={item.submenu ? "has-submenu disableExit" : ""}>
                            {item.icon}
                            {item.label}
                            {item.submenu && (
                                <ul
                                    className="submenu disableExit"
                                    style={{
                                        bottom: "-4px",
                                        left: adjustedPosition.x + 240 + 150 > window.innerWidth ? -150 : 240,
                                        backgroundColor: theme.palette.background.paper
                                    }}
                                >
                                    {/* <li className="disableExit">
                                            <Typography marginRight={'auto'} className="disableExit">Fade In</Typography>
                                            <Checkbox defaultChecked={false} className="disableExit" />
                                        </li> */}
                                    <li className="disableExit">

                                        <Slider
                                            aria-label="Temperature"
                                            value={volumeValue && volumeValue}
                                            valueLabelDisplay="auto"
                                            step={0.1}
                                            min={0}
                                            max={1}
                                            className="disableExit"
                                            onChange={(e) => { setVolumeValue(e.target.value) }}
                                            onChangeCommitted={changedVolume}
                                        />
                                    </li>
                                    {/* <li className="disableExit">
                                            <Typography marginRight={'auto'} className="disableExit">Fade Out</Typography>
                                            <Checkbox defaultChecked={false} className="disableExit" />
                                        </li> */}
                                </ul>
                            )}
                        </li>)
                    } else if (item.label === 'Opacity') {
                        return (<li key={index} className={item.submenu ? "has-submenu disableExit" : ""}>
                            {item.icon}
                            {item.label}
                            {item.submenu && (
                                <ul
                                    className="submenu disableExit"
                                    style={{
                                        bottom: "-4px",
                                        left: adjustedPosition.x + 240 + 150 > window.innerWidth ? -150 : 240,
                                        backgroundColor: theme.palette.background.paper
                                    }}
                                >
                                    <li className="disableExit">

                                        <Slider
                                            aria-label="Temperature"
                                            value={opacity}
                                            valueLabelDisplay="auto"
                                            step={0.1}
                                            marks
                                            min={0}
                                            max={1}
                                            className="disableExit"
                                            onChange={(e) => { setOpacity(e.target.value) }}
                                            onChangeCommitted={changedOpacity}

                                        />
                                    </li>
                                </ul>
                            )}
                        </li>)
                    } else if ((item.label === 'Fullscreen')) {
                        return (
                            <li key={index} className={"disableExit"} onClick={item.function} >
                                {item.icon}
                                {item.label}
                            </li>
                        )
                    } else {
                        return (
                            <li key={index} className={item.submenu ? "has-submenu" : ""} onClick={item.function && item.function}>
                                {item.icon}
                                {item.label}
                                {item.submenu && (
                                    <ul
                                        className="submenu"
                                        style={{
                                            top: "0px",
                                            left: adjustedPosition.x + 240 + 150 > window.innerWidth ? -150 : 240,
                                            backgroundColor: theme.palette.background.paper
                                        }}
                                    >
                                        {item.submenu.map((subItem, subIndex) => (
                                            <li key={subIndex}>
                                                {subItem.icon}
                                                {subItem.label}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        )
                    }
                }
                )}
            </ul>
        </div >
    )

}

export default ElementContextMenu;